import React from 'react';
import './ProductInfo.css';

const ProductInfo = ({ product }) => {
  const formatPrice = (price) => {
    if (!price) return "Liên hệ";
    return new Intl.NumberFormat("vi-VN", {
      style: "currency",
      currency: "VND",
    }).format(Number(price));
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("vi-VN");
  };

  // Mock data nếu không có product
  const mockProduct = product || {
    title: "Máy giặt Electrolux 7kg",
    price: 2500000,
    category: "Đồ gia dụng",
    condition: "Đã sử dụng",
    location: "Quận 1, TP.HCM",
    createdAt: "2024-01-15",
    tags: ["Máy giặt", "Electrolux", "7kg"],
    description: "Máy giặt còn mới, hoạt động tốt",
    warranty: "6 tháng",
    brand: "Electrolux"
  };

  return (
    <div className="product-info-container">
      {/* Product Header */}
      <div className="product-header">
        <div className="product-tags">
          {mockProduct.tags?.map((tag, index) => (
            <span key={index} className="product-tag">
              #{tag}
            </span>
          ))}
        </div>
        <h1 className="product-title">{mockProduct.title}</h1>
        <div className="product-meta">
          <span className="product-category">{mockProduct.category}</span>
          <span className="product-date">{formatDate(mockProduct.createdAt)}</span>
        </div>
      </div>

      {/* Price Section */}
      <div className="price-section">
        <div className="price-main">{formatPrice(mockProduct.price)}</div>
        <div className="price-details">
          <span className="currency">VND</span>
          <span className="condition">Tình trạng: {mockProduct.condition}</span>
        </div>
      </div>

      {/* Product Details */}
      <div className="product-details">
        <div className="detail-item">
          <span className="detail-icon">🏷️</span>
          <span className="detail-label">Thương hiệu:</span>
          <span className="detail-value">{mockProduct.brand}</span>
        </div>
        <div className="detail-item">
          <span className="detail-icon">🛡️</span>
          <span className="detail-label">Bảo hành:</span>
          <span className="detail-value">{mockProduct.warranty}</span>
        </div>
        <div className="detail-item">
          <span className="detail-icon">📍</span>
          <span className="detail-label">Địa chỉ:</span>
          <span className="detail-value">{mockProduct.location}</span>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="action-buttons">
        <button className="btn-call">
          <span>📞</span>
          Gọi ngay
        </button>
        <button className="btn-chat">
          <span>💬</span>
          Chat
        </button>
        <button className="btn-favorite">
          <span>❤️</span>
          Yêu thích
        </button>
      </div>

      {/* Quick Info */}
      <div className="quick-info">
        <div className="info-item">
          <span className="info-icon">👁️</span>
          <span>Đã xem: 1,234 lượt</span>
        </div>
        <div className="info-item">
          <span className="info-icon">💬</span>
          <span>Bình luận: 12</span>
        </div>
        <div className="info-item">
          <span className="info-icon">⭐</span>
          <span>Đánh giá: 4.8/5</span>
        </div>
      </div>
    </div>
  );
};
export default ProductInfo;
